import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { EventsState } from '../../../store/types';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import CreateUI from './create-ui';
import { Link } from 'react-router-dom';
import { PATHNAMES } from '../admin';
import EventName from '../create/homepage/editor/event-name';
import { getStartTime } from '../../../utils/get-event-start-time';
import TellyMarch from '../../../images/telly-march.svg';
import { ProfileDetails } from '../../general-ui/profile-details/profile-details';

interface EventHeaderProps {
	hideCreateUI?: boolean;
	linkText?: string;
	linkTo?: string | null;
	fullWidth?: boolean;
	showLogo?: boolean;
}

export default function EventHeader({
	hideCreateUI = false,
	linkText = '',
	linkTo = null,
	fullWidth = false,
	showLogo = false,
}: EventHeaderProps): JSX.Element {
	const {
		CreateEventReducer: {
			workingEvent,
			saving
		},
		AuthReducer: {
			user
		},
	} = useSelector((state: EventsState) => state);

	const [profileDetailsOpen, setProfileDetailsOpen] = useState(false);
	const [startTime, setStartTime] = useState<string | null | number>(null);
	const [creatingEvent, setCreatingEvent] = useState(false);


	useEffect(() => {
		setStartTime(getStartTime(workingEvent!, true));
	}, [workingEvent]);

	useEffect(() => {
		// this is a bit messy, but the header needs to have a transparent (dark) background while in the template selection and create event info screens.
		// Here, we check the url to see if the url ends exaclty with "admin/events/create" (we are in template selection) or ends in exactly "/info"
		// which would mean we are on the info page of the create event process
		if ((window.location.href.indexOf("/admin/events/create") > -1)) {
			const array = window.location.href.split('/admin/events/create');
			if (array.length > 1) {
				if ((array[array.length - 1] === "/info") || (array[array.length - 1].length === 0)) {
					setCreatingEvent(true);
				}
			}
		} else {
			setCreatingEvent(false);
		}
	}, []);

	return (
		<div className={classnames("event-header-wrapper", { 'full-page-width': fullWidth })}>
			<div className={classnames("event-header-container", { 'create-event-header': creatingEvent })}>
				<div className="left">
					{showLogo ? (
						<div className="header-telly-logo-wrapper">
							<img className="header-telly-logo" src={TellyMarch} alt="Telly Marching" />
						</div>
					) : null}
					<div className="pathing-arrow">
						<Link to={linkTo || PATHNAMES.Events}><Icon name={ICONS.CLOSE} size={16} color={COLORS.WHITE} />{linkText ? <span className="pathing-arrow-text">{linkText}</span> : null}</Link>
					</div>
					{workingEvent ? (
						<>
							<div className="event-title">
								<div className="title-top">
									<EventName />
									<div className="event-autosave-status">
										{saving ? "Saving changes" : "Autosaved"}
									</div>
								</div>
								<div className="title-bottom">
									<div className="event-start">{startTime}</div>
								</div>
							</div>
						</>
					) : (<></>)}
				</div>
				<div className="right">
					{hideCreateUI ? null : <CreateUI />}
					<button className={classnames("no-style", "profile-button", { 'no-button-border': hideCreateUI })}>
						<div className="profile-pic" onClick={() => setProfileDetailsOpen(!profileDetailsOpen)}>
							{user?.profile?.picture ? (
								<img
									src={user!.profile.picture}
									alt={
										user!.profile.first_name + ' ' + user!.profile.last_name
									}
								/>
							) : (
								<Icon
									name={ICONS.SETTINGS_TRANSPARENT}
									color={COLORS.BLACK}
									size={40}
								/>
							)}
						</div>
						<Icon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} color={COLORS.GRAY} />
					</button>
					<ProfileDetails
						open={profileDetailsOpen}
						account={user!}
						position={"top"}
						onClose={() => setProfileDetailsOpen(false)}
					>
					</ProfileDetails>
				</div>
			</div>
		</div>
	);
}